import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  private stateUrl: string;

  private roles = ['admin', 'AdminCROS', 'AdminMSR', 'AdminSITE'];

    constructor(
        private authSrv: AuthService,
        private router: Router,
    ) { }

    canActivate(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      this.stateUrl = state.url;

      const role = this.authSrv.getDecodedToken()?.role || null;

      // const isAdmin = ['admin', 'club', 'counter'].includes(role) ? true : false;
      const isAdmin = this.roles.includes(role) ? true : false;


      if (!isAdmin) {
          this.stateUrl === '/espace-pro' ?
              this.router.navigate(['/espace-pro']) :
              this.router.navigate([sessionStorage.getItem('route')]);
          return false;
      }

      return true;
    }




}
